/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Help_Product_Location_ManagementInputs */



/**
* | output |
* | --- |
* | "Product location management" |
*
* @param {Users_Help_Product_Location_ManagementInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const users_help_product_location_management = /** @type {((inputs?: Users_Help_Product_Location_ManagementInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Help_Product_Location_ManagementInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Product location management")
	return /** @type {LocalizedString} */ ("Gestion de l'emplacement des produits")
});